"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _tag = _interopRequireDefault(require("antd/lib/tag"));
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var prefixClassName = 'dpl-tag';
var DplCheckableTag = function DplCheckableTag(props) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 'small' : _props$size,
    className = props.className,
    restProps = __rest(props, ["size", "className"]);
  return /*#__PURE__*/_react["default"].createElement(_tag["default"].CheckableTag, (0, _extends2["default"])({
    className: (0, _classnames["default"])(className, "".concat(prefixClassName, "-").concat(size))
  }, restProps));
};
var DplTag = function DplTag(props) {
  var _props$size2 = props.size,
    size = _props$size2 === void 0 ? 'small' : _props$size2,
    className = props.className,
    restProps = __rest(props, ["size", "className"]);
  return /*#__PURE__*/_react["default"].createElement(_tag["default"], (0, _extends2["default"])({
    className: (0, _classnames["default"])(className, "".concat(prefixClassName, "-").concat(size))
  }, restProps));
};
DplTag.CheckableTag = DplCheckableTag;
var _default = exports["default"] = DplTag;